interface GreenScoreIconProps {
  isModalIcon?: boolean;
}

/**
 * GreenScoreIcon returns the svg for the Green Score Profile Card
 * @param props isModalIcon jfj
 * @returns JSX component for the Green Score Profile Leaf Icon
 */
function GreenScoreIcon(props: GreenScoreIconProps) {
  if (props.isModalIcon) {
    return (
      <svg
        id="uuid-07ba0cb2-f852-42b5-8ec2-d82cb3393589"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 120"
      >
        <g id="uuid-800b2d81-0d6d-4a75-a7f9-1defd590542d">
          <circle
            fill="white"
            id="uuid-71fc4e31-b4fe-42c7-91a9-fbe181f8ca05"
            cx="60"
            cy="60"
            r="60"
          />
          <path
            fill="#3ea436"
            id="uuid-743f5fcc-f749-4b11-9f2f-25c084921609"
            d="M77.01,78.55c.28.13.61.03.77-.24,3.08-5.37,6.03-6.52,10.5-8.25,2.71-1,5.34-2.21,7.86-3.62,5.19-2.74,9.18-7.32,11.2-12.83,1.62-5.08,1.7-10.53.22-15.65-.08-.32-.41-.5-.73-.42-.22.06-.39.24-.43.46-.47,2.52-3.76,4.66-9.78,6.35-1.54.43-3.15.81-4.71,1.17-6.75,1.57-13.73,3.2-17.52,9.92-1.88,3.34-2.28,7.3-1.28,12.84.51,2.54,1.15,5.05,1.92,7.51.08.25.31.41.57.41h0c.26,0,.49-.17.56-.42,1.28-4.5,3.42-8.7,6.32-12.37,1.54-1.88,3.29-3.56,5.23-5.03-4.87,5.71-8.6,12.3-11.01,19.41-.11.29.03.61.31.74"
          />
          <path
            fill="#3ea436"
            id="uuid-5e7c695f-a7cc-458d-8c0d-33ff877ddc59"
            d="M115.29,36.7C102.42,6.17,67.23-8.14,36.7,4.73,6.17,17.6-8.14,52.78,4.73,83.31c9.38,22.24,31.17,36.7,55.31,36.69,1.11,0,2.28-.03,3.47-.1,1.83-.1,3.66-.29,5.45-.56.25-.04.44-.22.49-.47.28-1.33.51-2.68.68-4.03,1.14-9.36.25-18.86-2.61-27.84-4.28-13.72-9.81-24.35-16.79-32.22,7.24,6.19,12.7,14.18,15.83,23.17.09.23.31.39.56.39h.01c.25,0,.48-.17.55-.41,1.04-3.33,1.9-6.72,2.59-10.14,1.34-7.44.82-12.76-1.71-17.24-5.08-9.02-14.48-11.21-23.58-13.33-2.11-.49-4.3-1-6.38-1.59-8.22-2.31-12.72-5.25-13.38-8.76-.06-.32-.37-.53-.69-.47-.22.04-.4.21-.46.43-1.79,7.18-1.25,14.75,1.56,21.61,2.7,6.89,7.53,12.75,13.79,16.71,1.56.96,3.25,1.91,5.03,2.92,3.72,1.96,7.26,4.22,10.61,6.76,4.5,3.68,7.68,8.73,9.05,14.37,1.32,5.52,1.71,11.22,1.18,16.87-.19,2.95-.6,5.88-1.24,8.77-1.34.1-2.68.15-4,.15-30.36-.02-54.94-24.65-54.92-55.01.02-22.06,13.22-41.97,33.53-50.57,27.94-11.83,60.19,1.23,72.02,29.17,7.82,18.47,4.95,39.73-7.48,55.47-7.51,9.5-17.93,16.26-29.66,19.26-.27.07-.45.31-.45.58.02,1.27,0,2.58-.07,3.92-.02.33.24.61.57.62.05,0,.11,0,.16-.01,27.12-6.34,46.29-30.53,46.26-58.38.02-8.02-1.58-15.96-4.71-23.34"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      id="uuid-11cffd5e-7a8b-41a6-ad93-04dcd370a424"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
    >
      <g id="uuid-5aef0252-1506-4bc2-8762-a814002db732">
        <path
          fill="#3ea436"
          id="uuid-720a8f6c-0675-499a-8673-8208d2b593ab"
          d="M77.01,78.55c.28.13.61.03.77-.24,3.08-5.37,6.03-6.52,10.5-8.25,2.71-1,5.34-2.21,7.86-3.62,5.19-2.74,9.18-7.32,11.2-12.83,1.62-5.08,1.7-10.53.22-15.65-.08-.32-.41-.5-.73-.42-.22.06-.39.24-.43.46-.47,2.52-3.76,4.66-9.78,6.35-1.54.43-3.15.81-4.71,1.17-6.75,1.57-13.73,3.2-17.52,9.92-1.88,3.34-2.28,7.3-1.28,12.84.51,2.54,1.15,5.05,1.92,7.51.08.25.31.41.57.41h0c.26,0,.49-.17.56-.42,1.28-4.5,3.42-8.7,6.32-12.37,1.54-1.88,3.29-3.56,5.23-5.03-4.87,5.71-8.6,12.3-11.01,19.41-.11.29.03.61.31.74"
        />
        <path
          fill="#3ea436"
          id="uuid-19e409da-c5e7-4af3-9a6d-7578185280a0"
          d="M115.29,36.7C102.42,6.17,67.23-8.14,36.7,4.73,6.17,17.6-8.14,52.78,4.73,83.31c9.38,22.24,31.17,36.7,55.31,36.69,1.11,0,2.28-.03,3.47-.1,1.83-.1,3.66-.29,5.45-.56.25-.04.44-.22.49-.47.28-1.33.51-2.68.68-4.03,1.14-9.36.25-18.86-2.61-27.84-4.28-13.72-9.81-24.35-16.79-32.22,7.24,6.19,12.7,14.18,15.83,23.17.09.23.31.39.56.39h.01c.25,0,.48-.17.55-.41,1.04-3.33,1.9-6.72,2.59-10.14,1.34-7.44.82-12.76-1.71-17.24-5.08-9.02-14.48-11.21-23.58-13.33-2.11-.49-4.3-1-6.38-1.59-8.22-2.31-12.72-5.25-13.38-8.76-.06-.32-.37-.53-.69-.47-.22.04-.4.21-.46.43-1.79,7.18-1.25,14.75,1.56,21.61,2.7,6.89,7.53,12.75,13.79,16.71,1.56.96,3.25,1.91,5.03,2.92,3.72,1.96,7.26,4.22,10.61,6.76,4.5,3.68,7.68,8.73,9.05,14.37,1.32,5.52,1.71,11.22,1.18,16.87-.19,2.95-.6,5.88-1.24,8.77-1.34.1-2.68.15-4,.15-30.36-.02-54.94-24.65-54.92-55.01.02-22.06,13.22-41.97,33.53-50.57,27.94-11.83,60.19,1.23,72.02,29.17,7.82,18.47,4.95,39.73-7.48,55.47-7.51,9.5-17.93,16.26-29.66,19.26-.27.07-.45.31-.45.58.02,1.27,0,2.58-.07,3.92-.02.33.24.61.57.62.05,0,.11,0,.16-.01,27.12-6.34,46.29-30.53,46.26-58.38.02-8.02-1.58-15.96-4.71-23.34"
        />
      </g>
    </svg>
  );
}

export default GreenScoreIcon;
